import "bootstrap/js/dist/modal"

const Modals = el => {
  return $(el).modal({ show: false })
}

export { Modals }
